const SET_LOGGED_IN_USER_DET = 'app/login/SET_LOGGED_IN_USER_DET';
const SET_VIEW_USER_DET = 'app/login/SET_VIEW_USER_DET';
const SET_USER_PROFILES = 'app/login/SET_USER_PROFILES';
const SET_SELECTED_PROFILE = 'app/login/SET_SELECTED_PROFILE';
const SET_DEFAULT_PROFILE = 'app/login/SET_DEFAULT_PROFILE';
const SET_PROFILES_LOADING = 'app/login/SET_PROFILES_LOADING';

const setUserDetail = (userDet) => ({
  type: SET_LOGGED_IN_USER_DET,
  userDet: userDet,
});

const setViewUserDetail = (userDet) => ({
  type: SET_VIEW_USER_DET,
  userDet: userDet,
});

const setUserProfiles = (profiles) => ({
  type: SET_USER_PROFILES,
  profiles,
});

const setSelectedProfile = (profile) => ({
  type: SET_SELECTED_PROFILE,
  profile,
});

const setDefaultProfile = (profileId) => ({
  type: SET_DEFAULT_PROFILE,
  profileId,
});

const setProfilesLoading = (loading) => ({
  type: SET_PROFILES_LOADING,
  loading,
});

export {
  SET_LOGGED_IN_USER_DET,
  SET_VIEW_USER_DET,
  SET_USER_PROFILES,
  SET_SELECTED_PROFILE,
  SET_DEFAULT_PROFILE,
  SET_PROFILES_LOADING,
  setUserDetail,
  setViewUserDetail,
  setUserProfiles,
  setSelectedProfile,
  setDefaultProfile,
  setProfilesLoading,
};
